<template>
    <div class="bg-white dark:bg-gray-800">
        <Hero :hero="params"></Hero>
        <Breadcrumbs :breadcrumbs="crumbs" :page="pagename"></Breadcrumbs>
        <content></content>
    </div>
</template>

<script>
import Breadcrumbs from '../layouts/breadcrumb.vue'
import Hero from '../layouts/Hero.vue'
import Content from '@/components/Other/FormLowongan.vue';
export default {
    name: 'ClientFormLowongan',

    data() {
        return {
            params:{},
            pagename: null,
            crumbs: [],
            pageparams: 'Formulir Lamaran Kerja'
        };
    },

    created() {
        this.getparams();
    },

    methods: {
        getparams(){
             this.axios.get('api/getbanner/'+this.pageparams).then((response) => {
               this.params = {
                    id: response.data.id,
                    title: response.data.type,
                    img: response.data.imagepath,
                    description : response.data.description,
                    showtitle : response.data.showtitle,
                    showdesc : response.data.showdesc,
                }

                this.crumbs = [
                    {key:"Karir", link:"/karir"},
                    {key:response.data.type, link: "/karir/"+response.data.permalink}
                ]

                document.title = response.data.type + ' | Bank Padma'
                document.querySelector('head meta[name="description"]').setAttribute('content', response.data.description);
                document.querySelector('head meta[name="og:description"]').setAttribute('content', response.data.description);
                document.querySelector('head meta[name="og:title"]').setAttribute('content', response.data.type + ' | Bank Padma');
                document.querySelector('head meta[name="keywords"]').setAttribute('content', response.data.keyword);
                document.querySelector('head meta[name="og:url"]').setAttribute('content', window.location.href);
                document.querySelector('head meta[name="og:image"]').setAttribute('content', response.data.imagepath);
            }).catch(error => {
                
            console.log(error)

            }).finally(() => {
                
            })
            
            
        }
    },
    components:{
        Breadcrumbs,
        Hero ,
        Content   
    }
};
</script>

<style lang="scss" scoped>

</style>